import React from "react";

import { Fade } from 'react-awesome-reveal';

function Sectiontitle({children, title}) {
  return (
    <Fade wait={10}>
      <div className="mi-sectiontitle">
        <h2>{title}</h2>
        <span>{title}</span>
      </div>
    </Fade>
  );
}

export default Sectiontitle;
